module.exports = __webpack_public_path__ + "img/book_320.fe979126.png";